import type { Quote, QuoteRow } from "./types";

// True when the selection is exactly the first N of the server's order.
export const isPrefixOf = (
  orderedIds: string[],
  selected: ReadonlySet<string>
): boolean =>
  orderedIds.slice(0, selected.size).every((id) => selected.has(id));

// The quote row for the selection: the rows price the first N contracts of
// the server's order, so a selection that isn't one of those prefixes has no
// row. When several rows share a count (small lists), the lowest rate wins
// (provisional: open question in thoughts/protect/pricing/spec.md).
export const quoteRowFor = (
  quote: Quote | undefined,
  orderedIds: string[],
  selected: ReadonlySet<string>
): QuoteRow | undefined => {
  if (!quote || !selected.size) return undefined;
  if (!isPrefixOf(orderedIds, selected)) return undefined;

  return [...quote.rows]
    .reverse()
    .find((row) => row.contractCount === selected.size);
};
